<template>
  <section class="error-page">
    <div class="fp-logo">
      <img src="@/assets/images/logo.png">
    </div>
    {{ this.message }}
  </section>
</template>

<script>
  export default {
    name: "ErrorPage",
    data() {
      return {
        message: this.$route.query.message,
      }
    },
  }
</script>